export enum Routes {
  PriceRouter = "*",
  PriceListSearchPageRouter = "/price/search",
  PriceListCreatePageRouter = "/price/create",
  PriceListEditPageRouter = "/price/:priceListId?",
  PriceListDetailPageRouter = '/price/detail/:priceListId',
}
